import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row, Tag } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FollowUpForm from '@app/components/apps/FollowUp/FollowUpForm';

export const ViewFollowUp: React.FC = () => {
  const location = useLocation();
  const { id, import_id, code } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Follow-Up');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [failureActions, setFailureActions] = useState<any[]>([]);
  const [actionAfterFail, setActionAfterFail] = useState<string>('');
  // console.log('ViewFollowUp received:', { id, import_id });
  const actionLabel = failureActions.find((item) => item.value === actionAfterFail)?.label || actionAfterFail;

  const actionColorMap: Record<string, string> = {
    RENEW: 'blue',
    DESTROYED: 'red',
    REEXPORTED: 'orange',
  };

  const routes = [
    {
      path: '/follow-ups',
      breadcrumbName: 'Follow-Ups',
    },
    {
      path: '/view-follow-up',
      breadcrumbName: code ? code : id,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <FollowUpForm
          type="view"
          editable={false}
          id={id}
          import_id={import_id}
          pageTitle={
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <span>View Follow-Up</span>

              {actionAfterFail && <Tag color={actionColorMap[actionAfterFail]}>{actionLabel}</Tag>}
            </div>
          }
          setCurrentBreadcrumName={setCurrentBreadcrumName}
          setActionAfterFail={setActionAfterFail}
          setFailureActions={setFailureActions}
        />
      </Row>
    </>
  );
};

export default ViewFollowUp;
